module.exports = __webpack_public_path__ + "static/media/Screen Shot 2021-07-20 at 2.41.11 PM.ef05f38d.png";